import React, { Fragment } from "react";
import { Theme, makeStyles, withStyles } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
import { TableRow, TableCell, IconButton, Switch } from "@material-ui/core";
// import { MainContext } from "../../context/main";
// import { useHistory } from "react-router-dom";
// import { LangContext } from "../../context/lang";
import { IUsers } from "../../interface/users";

const UserSwitch = withStyles((theme) => ({
  root: {
    width: 33,
    height: 17,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#30d126",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#30d126",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 14,
    height: 14,
  },
  track: {
    borderRadius: 26 / 2,
    backgroundColor: "#ff3333",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }: any) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

interface IRowTable {
  data: IUsers;
  onEnabled: any;
  clickDelete: Function;
}

const useStyle = makeStyles((theme: Theme) => ({
  removeBorderBottom: {},
  searchBtn: { textTransform: "unset" },
  inprocessText: { fontWeight: 600, color: theme.palette.warning.main },
  completeText: { fontWeight: 600, color: theme.palette.success.main },
  removeIcon: { color: theme.palette.error.main },
}));

const UserRowTable = (props: IRowTable) => {
  const classes = useStyle();
  // const { userInfo } = useContext(MainContext);
  // const { lang } = useContext(LangContext);
  // const history = useHistory();

  const { data, onEnabled } = props;

  const showOrganization = () => {
    if (data.organization) {
      return data.organization;
    } else if (data.mea) {
      return "MEA";
    } else {
      return "-";
    }
  };
  return (
    <Fragment>
      <TableRow>
        <TableCell className={classes.removeBorderBottom}>
          {`${data.first_name} ${data.last_name}`}
        </TableCell>
        <TableCell className={classes.removeBorderBottom}>
          {showOrganization()}
        </TableCell>
        <TableCell className={classes.removeBorderBottom} align="center">
          {`${data.role
            .split("_")
            .join(" ")
            .charAt(0)
            .toUpperCase()}${data.role.split("_").join(" ").slice(1)}`}
        </TableCell>
        <TableCell className={classes.removeBorderBottom} align="center">
          <UserSwitch
            checked={data.enabled}
            name={`${data._id}`}
            onChange={(e: any) => {
              onEnabled(data._id, e.target.checked);
            }}
          />
        </TableCell>
        <TableCell className={classes.removeBorderBottom} align="center">
          <IconButton
            size="small"
            className={classes.removeIcon}
            onClick={() => {
              props.clickDelete(data._id);
            }}
          >
            <Delete />
          </IconButton>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};

export default UserRowTable;
